import script from "./compIOCDetailDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./compIOCDetailDrawer.vue?vue&type=script&setup=true&lang=js"

import "./compIOCDetailDrawer.vue?vue&type=style&index=0&id=7c03359f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c03359f"]])

export default __exports__